import { createSlice } from "@reduxjs/toolkit";

const botResponseSlice = createSlice({
    name: "botResponse",
    initialState: {
        botResponse: '',
        modelCompletion: '',
        hintText: '',
    },
    reducers: {
        updateBotResponse: (state, action) => {
            const token = action.payload;
            state.botResponse = state.botResponse.concat(token).replace(/\\n/g, '<br/>');
        },
        updateModelCompletion: (state, action) => {
            const token = action.payload;
            state.modelCompletion = state.modelCompletion.concat(token);
        },
        setHintText: (state, action) => {
            state.hintText = action.payload;
        },
        resetBotResponse: (state) => {
            state.botResponse = '';
            state.modelCompletion = '';
        },
    },
});

export const { updateBotResponse, updateModelCompletion, setHintText, resetBotResponse } = botResponseSlice.actions;

export default botResponseSlice.reducer;
